import $ from 'jquery';

$('.close').on('click', function() {
$('.popup')
  .removeClass('opacity-1');
$('.soft-overlay-popup')
  .removeClass('opacity');
$('html')
  .removeClass('no-scroll');
});

$('#popup-page').on('click', function() {
$('.popup')
  .addClass('opacity-1');
$('.soft-overlay-popup')
  .addClass('opacity');
$('html')
  .addClass('no-scroll');
});

$('.popup').on('scroll', function() {
  $('.scroll')
    .fadeOut();
});



// WEBPACK FOOTER //
// ./wp/wp-content/themes/brockmeyer-chisel/src/scripts/additional/popup.js